/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const NextIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
    >
      <path
        d="M0.512075 0.505083C0.184095 0.825008 1.264e-06 1.25778 1.22994e-06 1.70889C1.19589e-06 2.15999 0.184095 2.59276 0.512075 2.91269L6.74588 9.04269L0.512074 15.0873C0.184094 15.4072 1.63074e-07 15.84 1.29017e-07 16.2911C9.49598e-08 16.7422 0.184094 17.175 0.512074 17.4949C0.675778 17.655 0.870542 17.782 1.08513 17.8687C1.29972 17.9554 1.52989 18 1.76236 18C1.99482 18 2.22499 17.9554 2.43958 17.8687C2.65417 17.782 2.84893 17.655 3.01264 17.4949L10.4791 10.255C10.6442 10.0963 10.7752 9.90744 10.8646 9.69936C10.954 9.49129 11 9.2681 11 9.04269C11 8.81728 10.954 8.59409 10.8646 8.38602C10.7752 8.17794 10.6442 7.98909 10.4791 7.83035L3.01264 0.505083C2.84894 0.34504 2.65417 0.218012 2.43958 0.131323C2.22499 0.044634 1.99483 1.50605e-07 1.76236 1.33054e-07C1.52989 1.15503e-07 1.29972 0.044634 1.08513 0.131323C0.870544 0.218012 0.67578 0.345039 0.512075 0.505083Z"
        fill="white"
      />
    </svg>
  )
}
